export const CityServices = ({ city }) => (
<div className="bg-black/60 p-4 rounded-xl border border-yellow-400/30">
                      <h4 className="font-bold text-yellow-400 mb-3 text-lg">Services Marabout Africain à {city} :</h4>
                      <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
                        <li>✓ Retour Affectif Rapide {city}</li>
                        <li>✓ Marabout Africain {city}</li>
                        <li>✓ Sorcier Vaudou Haïtien {city}</li>
                        <li>✓ Voyant Médium Sérieux {city}</li>
                        <li>✓ Marabout Sérieux Retour Ex {city}</li>
                        <li>✓ Rituel Amour Puissant {city}</li>
                        <li>✓ Magie Blanche Rouge Noire {city}</li>
                        <li>✓ Désenvoûtement Efficace {city}</li>
                        <li>✓ Récupérer son Ex {city}</li>
                        <li>✓ Voyance Sérieuse {city}</li>
                        <li>✓ Protection Spirituelle {city}</li>
                        <li>✓ Guérisseur Spirituel {city}</li>
                      </ul>
                    </div>
);
